import React from 'react';
import { 
  BuildingImg, 
  PrimaryLookImg, 
  IconLogoImg, 
  AgregatorLogoImg, 
  PlatformLogoImg, 
  RoomLogoImg, 
  PammLogoImg,
} from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
  Description 
} from '@Main/elements';
import { DownloadFile } from '@helpers';
import { getImage } from "gatsby-plugin-image"

export const LogoPage = ({getPng, getZip, t}) => {

    return (  
      <PageWrapper darkMode={true}>
        <FlexDiv>
          <BuildingImg image={getImage(getPng("building"))} alt='building'/>
          <Text width='350px' marginLeft='30px' marginTop='60px' paddingBefforeText="45px">
            <h1>{t("Logo")}</h1>
            <p>
              {t("The logo is one of the main elements of the company's identity. The logo is a combination of visual graphic elements and fonts. The graphic elements in the form of petals make up the symbol associated with the company and its products. The fonts are specially selected and designed in a coherent composition to match the symbol.")}
            </p>
          </Text>
        </FlexDiv>
        <Container paddingTop='131px' marginLeft='102px' border={true} marginRight='57px' paddingBottom='120px'>
          <FlexDiv>
            <Text width='329px' paddingAffterText="30px" paddingBefforeText="45px">
              <h1>{t("The primary look")}</h1>
              <p>
                {t("The primary logo is a combination of fonts and a petal pattern. It can be used for a company website, marketing materials, and presentations of any kind. The main colors of the logo are presented here.")} 
              </p>
              <DownloadFile darkMode={true} fileName='primary_logo' file={getZip('primary_logo')}/>
            </Text>
            <PrimaryLookImg />
          </FlexDiv>
        </Container>
        <Container marginTop='120px' marginLeft='102px' border={true} marginRight='57px' paddingBottom='120px'>
          <FlexDiv>
            <Text width='335px' paddingAffterText="40px" paddingBefforeText="45px">
              <h1>{t("Logo variation: a petal icon")}</h1>
              <p>
                {t("In some cases, it is possible to use only the icon with petals for visual representation, when the format of the document or media file does not provide enough space to fit the entire logo.")} 
              </p>
              <DownloadFile darkMode={true} fileName='icon_logo' file={getZip('icon_logo')}/>
            </Text>
            <IconLogoImg />
          </FlexDiv>
        </Container>
        <Container marginTop='120px' marginLeft='102px' marginRight='57px' paddingBottom='203px'>
          <FlexDiv>
            <Text width='312px' paddingAffterText="40px" paddingBefforeText="45px">
              <h1>{t("Additional logo colors")}</h1>
              <p>
                {t("If the logo is used in media describing specific Soft-FX products, additional colors are used in the petal icon. Please note that this is only applicable to specific products presented below.")}
              </p>
              <DownloadFile darkMode={true} fileName='liquidity_agregator_logo' file={getZip('liquidity_agregator_logo')}/>
              <DownloadFile darkMode={true} fileName='trading_platform_logo' file={getZip('trading_platform_logo')}/>
              <DownloadFile darkMode={true} fileName='traders_room_logo' file={getZip('traders_room_logo')}/>
              <DownloadFile darkMode={true} fileName='pamm_logo' file={getZip('pamm_logo')}/>
            </Text>
            <div>
              <Description marginTop='84px' marginLeft='139px'>
                <AgregatorLogoImg />
                <p>{t("TickTrader Liquidity Agregator")}</p>
              </Description>
              <Description marginTop='70px' marginLeft='139px'>
                <PlatformLogoImg />
                <p>{t("TickTrader Trading Platform")}</p>
              </Description>
              <Description marginTop='70px' marginLeft='139px'>
                <RoomLogoImg />
                <p>{t("TickTrader Traders Room")}</p>
              </Description>
              <Description marginTop='70px' marginLeft='139px'>
                <PammLogoImg />
                <p>{t("TickTrader PAMM")}</p>
              </Description>
            </div>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
